var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 132,
    viewBox: "0 0 137 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3001 118.621C98.3001 118.621 121 95.921 121 67.821C121 39.721 98.2001 17.021 70.3001 17.021C42.3001 17.021 19.6001 39.721 19.6001 67.821C19.6001 95.921 42.3001 118.621 70.3001 118.621Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.15 100.598C126.414 100.598 128.25 98.7623 128.25 96.4979C128.25 94.2336 126.414 92.3979 124.15 92.3979C121.886 92.3979 120.05 94.2336 120.05 96.4979C120.05 98.7623 121.886 100.598 124.15 100.598Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.15 84.598C131.696 84.598 132.95 83.3444 132.95 81.798C132.95 80.2516 131.696 78.998 130.15 78.998C128.604 78.998 127.35 80.2516 127.35 81.798C127.35 83.3444 128.604 84.598 130.15 84.598Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 34.4208C23.8464 34.4208 25.1 33.1672 25.1 31.6208C25.1 30.0744 23.8464 28.8208 22.3 28.8208C20.7536 28.8208 19.5 30.0744 19.5 31.6208C19.5 33.1672 20.7536 34.4208 22.3 34.4208Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 88.421C8.07188 88.421 10.4 86.0929 10.4 83.221C10.4 80.3491 8.07188 78.021 5.2 78.021C2.32812 78.021 0 80.3491 0 83.221C0 86.0929 2.32812 88.421 5.2 88.421Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6613 86.2388H65.3941C62.7834 86.2388 60.585 88.6471 60.585 91.507V97.6783C60.585 104 65.2567 109.118 71.0277 109.118C76.7987 109.118 81.4705 104 81.4705 97.6783V91.507C81.4705 88.4966 79.272 86.2388 76.6613 86.2388Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_4887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 20.4209C73.1876 20.4209 75.6611 22.8934 75.6611 26.0527V27.1045C86.6858 29.6545 94.8973 39.5281 94.8975 51.3271V54.4873C94.8977 81.1022 114.909 98.5367 114.959 98.5801H24.959C25.0085 98.5373 45.157 81.1026 45.1572 54.4873V51.3271C45.1574 39.528 53.3697 29.6544 64.3945 27.1045V26.0527C64.3945 22.8935 66.8672 20.4211 70.0273 20.4209Z",
    fill: "url(#paint0_linear_2447_4887)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.585 65.3381C56.1499 65.3381 53.2644 63.1403 52.1652 59.981C51.8904 59.2942 52.3026 58.6074 52.9896 58.3326C53.6766 58.0579 54.3637 58.47 54.6385 59.1568C55.3255 61.2172 57.3866 62.7282 59.585 62.7282C61.7835 62.7282 63.8446 61.3546 64.5316 59.1568C64.8064 58.47 65.4934 58.0579 66.1804 58.3326C66.8675 58.6074 67.2797 59.2942 67.0049 59.981C65.9056 63.2777 63.0201 65.3381 59.585 65.3381Z",
    fill: "#ADB6C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3331 65.3381C76.898 65.3381 74.0125 63.1403 72.9132 59.981C72.6384 59.2942 73.0506 58.6074 73.7377 58.3326C74.4247 58.0579 75.1117 58.47 75.3865 59.1568C76.0735 61.2172 78.1346 62.7282 80.3331 62.7282C82.5315 62.7282 84.5926 61.3546 85.2796 59.1568C85.5545 58.47 86.2415 58.0579 86.9285 58.3326C87.6155 58.6074 88.0277 59.2942 87.7529 59.981C86.6537 63.2777 83.7682 65.3381 80.3331 65.3381Z",
    fill: "#ADB6C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0277 82.1571C71.7731 82.1571 73.188 80.7426 73.188 78.9977C73.188 77.2529 71.7731 75.8384 70.0277 75.8384C68.2823 75.8384 66.8674 77.2529 66.8674 78.9977C66.8674 80.7426 68.2823 82.1571 70.0277 82.1571Z",
    fill: "#ADB6C8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9619 4.64967V0H104.932V4.64967L92.67 19.4441H105.143V24.0937H86.3276V19.4441L98.5896 4.64967H86.9619Z",
    fill: "url(#paint1_linear_2447_4887)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.761 39.5224V36.5635H113.388V39.5224L105.566 49.0331H113.6V51.9919H101.338V49.0331L109.16 39.5224H101.761Z",
    fill: "url(#paint2_linear_2447_4887)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_4887",
    x: 2.95898,
    y: 9.4209,
    width: 134,
    height: 122.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_4887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_4887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_4887",
    x1: 69.9297,
    y1: 18.613,
    x2: 69.9297,
    y2: 99.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2447_4887",
    x1: 95.737,
    y1: 0.836988,
    x2: 95.737,
    y2: 14.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2447_4887",
    x1: 107.47,
    y1: 37.0994,
    x2: 107.47,
    y2: 45.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no-notifications.8c018ac29e34b5614061f7a6e4245df6.svg";
export { ForwardRef as ReactComponent };